import { HandleErrorProps } from './errorType';

export const licenseErrorHandler = ({
  code,
  showAlert,
  t,
}: HandleErrorProps) => {
  switch (code) {
    case 'E_R2SOFTWARE_003':
      showAlert({
        message: t('licenseManagement.messages.licenseKeyNotFound'),
      });
      break;
    case 'E_R2SOFTWARE_007':
      showAlert({
        message: t('licenseManagement.messages.memoAlreadyRegistered'),
      });
      break;
    case 'E_VALIDATION_MEMO_NOT_BLACK':
      showAlert({
        message: t('licenseManagement.messages.memoRequired'),
      });
      break;
    case 'E_R2SOFTWARE_006':
      showAlert({
        message: t('licenseManagement.messages.cannotRevoke'),
      });
      break;
    default:
      showAlert({
        message: t('common.failConnect'),
      });
      break;
  }
};
